// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/executions/executions.proto (package aurora.core.apiengine.executionsv1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Currency, PbInstrument, PbInstrumentInfo } from "../../../../common/protos/types_pb";
import { file_common_protos_types } from "../../../../common/protos/types_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { InstrumentIdType } from "../../../../consts/omsconsts_pb";
import { file_consts_omsconsts } from "../../../../consts/omsconsts_pb";
import type { RoundingRule } from "../../../../consts/loanconsts_pb";
import { file_consts_loanconsts } from "../../../../consts/loanconsts_pb";
import type { SettlementType } from "../../../../consts/settlementconsts_pb";
import { file_consts_settlementconsts } from "../../../../consts/settlementconsts_pb";
import type { Side } from "../../../../consts/commonconsts_pb";
import { file_consts_commonconsts } from "../../../../consts/commonconsts_pb";
import type { SortOrder } from "../../../../consts/queryconsts_pb";
import { file_consts_queryconsts } from "../../../../consts/queryconsts_pb";
import type { CollateralType } from "../../../../consts/agreementconsts_pb";
import { file_consts_agreementconsts } from "../../../../consts/agreementconsts_pb";
import type { Agreement } from "../agreements/agreements_pb";
import { file_modules_apiengine_services_agreements_agreements } from "../agreements/agreements_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/executions/executions.proto.
 */
export const file_modules_apiengine_services_executions_executions: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_protos_types, file_google_protobuf_empty, file_consts_omsconsts, file_consts_loanconsts, file_consts_settlementconsts, file_consts_commonconsts, file_consts_queryconsts, file_consts_agreementconsts, file_modules_apiengine_services_agreements_agreements]);

/**
 * @generated from message aurora.core.apiengine.executionsv1.ListExecutionsRequest
 */
export type ListExecutionsRequest = Message<"aurora.core.apiengine.executionsv1.ListExecutionsRequest"> & {
  /**
   * @generated from field: optional aurora.core.consts.common.Side side = 1;
   */
  side?: Side;

  /**
   * Limit the execution list to a certain agreement
   *
   * @generated from field: optional string agreement_id = 2;
   */
  agreementId?: string;

  /**
   * Limit the execution list to a security
   *
   * @generated from field: optional string instrument_id = 3;
   */
  instrumentId?: string;

  /**
   * @generated from field: optional aurora.core.consts.oms.InstrumentIdType instrument_id_type = 4;
   */
  instrumentIdType?: InstrumentIdType;

  /**
   * DateTime for query to start looking for executions - time in RFC3339 with millisecond precision
   *
   * @generated from field: string since = 5;
   */
  since: string;

  /**
   * DateTime for the end of the time window for which to search - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string until = 6;
   */
  until?: string;

  /**
   * optional filter by acknowledged status
   *
   * @generated from field: optional bool is_acknowledged = 7;
   */
  isAcknowledged?: boolean;
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.ListExecutionsRequest.
 * Use `create(ListExecutionsRequestSchema)` to create a new message.
 */
export const ListExecutionsRequestSchema: GenMessage<ListExecutionsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 0);

/**
 * @generated from message aurora.core.apiengine.executionsv1.ListExecutionsResponse
 */
export type ListExecutionsResponse = Message<"aurora.core.apiengine.executionsv1.ListExecutionsResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.executionsv1.Execution executions = 1;
   */
  executions: Execution[];
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.ListExecutionsResponse.
 * Use `create(ListExecutionsResponseSchema)` to create a new message.
 */
export const ListExecutionsResponseSchema: GenMessage<ListExecutionsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 1);

/**
 * @generated from message aurora.core.apiengine.executionsv1.Execution
 */
export type Execution = Message<"aurora.core.apiengine.executionsv1.Execution"> & {
  /**
   * A execution reference ID assigned by Provable Markets
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Id of the order
   *
   * @generated from field: string order_id = 2;
   */
  orderId: string;

  /**
   * The CUSIP of the instrument in the order
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 3;
   */
  instrument?: PbInstrument;

  /**
   * Side of the trade (Borrower, Lender)
   *
   * @generated from field: aurora.core.consts.common.Side side = 4;
   */
  side: Side;

  /**
   * Company id of the counterparty
   *
   * @generated from field: string counterparty_id = 5;
   */
  counterpartyId: string;

  /**
   * Executed quantity
   *
   * @generated from field: int64 execution_quantity = 6;
   */
  executionQuantity: bigint;

  /**
   * Last prior day market price
   *
   * @generated from field: string unit_price = 7;
   */
  unitPrice: string;

  /**
   * Deprecated. Please use collateral_price.
   *
   * @generated from field: string settlement_price = 23;
   */
  settlementPrice: string;

  /**
   * The collateral_rate adjusted price rounded up.
   *
   * @generated from field: string collateral_price = 25;
   */
  collateralPrice: string;

  /**
   * Rate as fee
   *
   * @generated from field: string fee = 8;
   */
  fee: string;

  /**
   * Rate as rebate
   *
   * @generated from field: string rebate = 9;
   */
  rebate: string;

  /**
   * Deprecated. Please use contract_value.
   *
   * @generated from field: string settlement_amount = 10;
   */
  settlementAmount: string;

  /**
   * The contract value (calculated as Collateral Adjusted Price * Quantity)
   *
   * @generated from field: string contract_value = 24;
   */
  contractValue: string;

  /**
   * Start date
   * deprecated
   *
   * @generated from field: string start_date = 11;
   */
  startDate: string;

  /**
   * date and time of the execution - time in RFC3339 with millisecond precision
   *
   * @generated from field: string execution_time = 12;
   */
  executionTime: string;

  /**
   * trade date - date in YYYY-MM-DD format
   *
   * @generated from field: string trade_date = 21;
   */
  tradeDate: string;

  /**
   * settlement date - date in YYYY-MM-DD format
   *
   * @generated from field: string settlement_date = 22;
   */
  settlementDate: string;

  /**
   * has the execution been acknowledged
   *
   * @generated from field: bool is_acknowledged = 13;
   */
  isAcknowledged: boolean;

  /**
   * Execution status
   *
   * @generated from field: string status = 14;
   */
  status: string;

  /**
   * Execution status of other side
   *
   * @generated from field: string contra_status = 15;
   */
  contraStatus: string;

  /**
   * Reason of cancellation if status is cancelled
   *
   * @generated from field: optional string cancel_reason = 16;
   */
  cancelReason?: string;

  /**
   * Last Updated - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;

  /**
   * Order created by user
   *
   * @generated from field: string order_created_by = 18;
   */
  orderCreatedBy: string;

  /**
   * Order last updated by user
   *
   * @generated from field: string order_last_updated_by = 19;
   */
  orderLastUpdatedBy: string;

  /**
   * Agreement details
   *
   * @generated from field: aurora.core.apiengine.agreementsv1.Agreement agreement = 20;
   */
  agreement?: Agreement;

  /**
   * Market value of the execution
   *
   * @generated from field: string market_value = 26;
   */
  marketValue: string;
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.Execution.
 * Use `create(ExecutionSchema)` to create a new message.
 */
export const ExecutionSchema: GenMessage<Execution> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 2);

/**
 * @generated from message aurora.core.apiengine.executionsv1.ExecutionEvent
 */
export type ExecutionEvent = Message<"aurora.core.apiengine.executionsv1.ExecutionEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * Details of the execution
   *
   * @generated from field: aurora.core.apiengine.executionsv1.Execution execution = 3;
   */
  execution?: Execution;
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.ExecutionEvent.
 * Use `create(ExecutionEventSchema)` to create a new message.
 */
export const ExecutionEventSchema: GenMessage<ExecutionEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 3);

/**
 * @generated from message aurora.core.apiengine.executionsv1.QueryExecutionRecordsRequest
 */
export type QueryExecutionRecordsRequest = Message<"aurora.core.apiengine.executionsv1.QueryExecutionRecordsRequest"> & {
  /**
   * New unique identifier for the request, assigned by the user
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Number of execution records per page; at most this many records will be returned
   *
   * @generated from field: int32 page_limit = 2;
   */
  pageLimit: number;

  /**
   * Number of the page to be returned considering the page_size
   *
   * @generated from field: int32 page_number = 3;
   */
  pageNumber: number;

  /**
   * Filtering options
   *
   * @generated from field: optional aurora.core.apiengine.executionsv1.QueryExecutionRecordsFilter filter = 4;
   */
  filter?: QueryExecutionRecordsFilter;

  /**
   * List of sorting options
   *
   * @generated from field: repeated aurora.core.apiengine.executionsv1.QueryExecutionRecordsSorting sorts = 5;
   */
  sorts: QueryExecutionRecordsSorting[];
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.QueryExecutionRecordsRequest.
 * Use `create(QueryExecutionRecordsRequestSchema)` to create a new message.
 */
export const QueryExecutionRecordsRequestSchema: GenMessage<QueryExecutionRecordsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 4);

/**
 * @generated from message aurora.core.apiengine.executionsv1.QueryExecutionRecordsResponse
 */
export type QueryExecutionRecordsResponse = Message<"aurora.core.apiengine.executionsv1.QueryExecutionRecordsResponse"> & {
  /**
   * The request_id provided in the original request
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Total number of Execution Records returned
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * The list of Execution Records that the query returned
   *
   * @generated from field: repeated aurora.core.apiengine.executionsv1.FrontendExecution exec_recs = 3;
   */
  execRecs: FrontendExecution[];

  /**
   * Users referenced in the Execution Records
   *
   * @generated from field: map<string, string> users = 4;
   */
  users: { [key: string]: string };

  /**
   * Instruments referenced in the Execution Records
   *
   * @generated from field: map<string, aurora.core.common.protos.PbInstrumentInfo> instruments = 5;
   */
  instruments: { [key: string]: PbInstrumentInfo };
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.QueryExecutionRecordsResponse.
 * Use `create(QueryExecutionRecordsResponseSchema)` to create a new message.
 */
export const QueryExecutionRecordsResponseSchema: GenMessage<QueryExecutionRecordsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 5);

/**
 * @generated from message aurora.core.apiengine.executionsv1.QueryExecutionRecordsFilter
 */
export type QueryExecutionRecordsFilter = Message<"aurora.core.apiengine.executionsv1.QueryExecutionRecordsFilter"> & {
  /**
   * CUSIP or ticker of instrument
   *
   * @generated from field: repeated string instruments = 1;
   */
  instruments: string[];

  /**
   * Limit the query to executions that are already or not-yet acknowledged
   *
   * @generated from field: optional bool is_acknowledged = 2;
   */
  isAcknowledged?: boolean;

  /**
   * Limit the query specific executions
   *
   * @generated from field: repeated string execution_ids = 3;
   */
  executionIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.QueryExecutionRecordsFilter.
 * Use `create(QueryExecutionRecordsFilterSchema)` to create a new message.
 */
export const QueryExecutionRecordsFilterSchema: GenMessage<QueryExecutionRecordsFilter> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 6);

/**
 * @generated from message aurora.core.apiengine.executionsv1.QueryExecutionRecordsSorting
 */
export type QueryExecutionRecordsSorting = Message<"aurora.core.apiengine.executionsv1.QueryExecutionRecordsSorting"> & {
  /**
   * Field to sort by
   *
   * @generated from field: aurora.core.apiengine.executionsv1.QueryExecutionRecordsSortableField field = 1;
   */
  field: QueryExecutionRecordsSortableField;

  /**
   * Sorting order
   *
   * @generated from field: aurora.core.consts.query.SortOrder order = 2;
   */
  order: SortOrder;
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.QueryExecutionRecordsSorting.
 * Use `create(QueryExecutionRecordsSortingSchema)` to create a new message.
 */
export const QueryExecutionRecordsSortingSchema: GenMessage<QueryExecutionRecordsSorting> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 7);

/**
 * @generated from message aurora.core.apiengine.executionsv1.AckExecutionsRequest
 */
export type AckExecutionsRequest = Message<"aurora.core.apiengine.executionsv1.AckExecutionsRequest"> & {
  /**
   * ack or unack the executions
   *
   * @generated from field: bool is_acknowledged = 1;
   */
  isAcknowledged: boolean;

  /**
   * executions to ack/unack
   *
   * @generated from field: repeated string execution_ids = 2;
   */
  executionIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.AckExecutionsRequest.
 * Use `create(AckExecutionsRequestSchema)` to create a new message.
 */
export const AckExecutionsRequestSchema: GenMessage<AckExecutionsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 8);

/**
 * @generated from message aurora.core.apiengine.executionsv1.AckExecutionsResponse
 */
export type AckExecutionsResponse = Message<"aurora.core.apiengine.executionsv1.AckExecutionsResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.AckExecutionsResponse.
 * Use `create(AckExecutionsResponseSchema)` to create a new message.
 */
export const AckExecutionsResponseSchema: GenMessage<AckExecutionsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 9);

/**
 * @generated from message aurora.core.apiengine.executionsv1.CustomExportAndAckExecutionRecordsRequest
 */
export type CustomExportAndAckExecutionRecordsRequest = Message<"aurora.core.apiengine.executionsv1.CustomExportAndAckExecutionRecordsRequest"> & {
  /**
   * @generated from field: aurora.core.apiengine.executionsv1.ExecutionsReportType type = 1;
   */
  type: ExecutionsReportType;

  /**
   * @generated from field: repeated string execution_ids = 2;
   */
  executionIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.CustomExportAndAckExecutionRecordsRequest.
 * Use `create(CustomExportAndAckExecutionRecordsRequestSchema)` to create a new message.
 */
export const CustomExportAndAckExecutionRecordsRequestSchema: GenMessage<CustomExportAndAckExecutionRecordsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 10);

/**
 * @generated from message aurora.core.apiengine.executionsv1.CustomExportAndAckExecutionRecordsResponse
 */
export type CustomExportAndAckExecutionRecordsResponse = Message<"aurora.core.apiengine.executionsv1.CustomExportAndAckExecutionRecordsResponse"> & {
  /**
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.CustomExportAndAckExecutionRecordsResponse.
 * Use `create(CustomExportAndAckExecutionRecordsResponseSchema)` to create a new message.
 */
export const CustomExportAndAckExecutionRecordsResponseSchema: GenMessage<CustomExportAndAckExecutionRecordsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 11);

/**
 * @generated from message aurora.core.apiengine.executionsv1.FrontendExecution
 */
export type FrontendExecution = Message<"aurora.core.apiengine.executionsv1.FrontendExecution"> & {
  /**
   * Execution ID
   *
   * @generated from field: string exec_id = 1;
   */
  execId: string;

  /**
   * Execution time - in RFC3339 with millisecond precision
   *
   * @generated from field: string exec_time = 2;
   */
  execTime: string;

  /**
   * Aurora Order Display ID of the order that was (partially) executed
   *
   * @generated from field: string order_display_id = 3;
   */
  orderDisplayId: string;

  /**
   * The CUSIP of the instrument in the order
   *
   * @generated from field: string cusip = 4;
   */
  cusip: string;

  /**
   * The side of the order
   *
   * @generated from field: aurora.core.consts.common.Side side = 5;
   */
  side: Side;

  /**
   * Owner of the order
   *
   * @generated from field: string company_id = 6;
   */
  companyId: string;

  /**
   * Aurora internal ID for the counterparty company
   *
   * @generated from field: string counterparty_id = 7;
   */
  counterpartyId: string;

  /**
   * Aurora internal ID for the agreement related to the (partially) executed order
   *
   * @generated from field: string agreement_id = 8;
   */
  agreementId: string;

  /**
   * Executed quantity
   *
   * @generated from field: int64 exec_qty = 9;
   */
  execQty: bigint;

  /**
   * Unit price at time of execution
   *
   * @generated from field: string unit_price = 10;
   */
  unitPrice: string;

  /**
   * collateral price of the execution including round and overcollateralization;
   *
   * @generated from field: string collateral_price = 33;
   */
  collateralPrice: string;

  /**
   * Rate as fee
   *
   * @generated from field: string fee = 11;
   */
  fee: string;

  /**
   * Rate as rebate
   *
   * @generated from field: string rebate = 12;
   */
  rebate: string;

  /**
   * Contract value
   *
   * @generated from field: string contract_value = 13;
   */
  contractValue: string;

  /**
   * Settlement type
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 14;
   */
  settlementType: SettlementType;

  /**
   * Collateral rate
   *
   * @generated from field: string collateral_rate = 15;
   */
  collateralRate: string;

  /**
   * Rounding rule
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 16;
   */
  roundingRule: RoundingRule;

  /**
   * Collateral type
   *
   * @generated from field: aurora.core.consts.agreements.CollateralType collateral_type = 17;
   */
  collateralType: CollateralType;

  /**
   * Trade date
   *
   * @generated from field: string trade_date = 18;
   */
  tradeDate: string;

  /**
   * Settlement date
   *
   * @generated from field: string settlement_date = 32;
   */
  settlementDate: string;

  /**
   * Aurora internal ID of the user who created the (partially) matched order
   *
   * @generated from field: string order_created_by = 19;
   */
  orderCreatedBy: string;

  /**
   * Aurora internal ID of the user who last amended the (partially) matched order
   *
   * @generated from field: string order_last_updated_by = 20;
   */
  orderLastUpdatedBy: string;

  /**
   * Status of the created contract, if managed by Aurora; otherwise empty
   *
   * @generated from field: optional int32 trade_status = 21;
   */
  tradeStatus?: number;

  /**
   * Aurora external ID of the contract, a.k.a. Contract ID if managed by Aurora; otherwise empty
   *
   * @generated from field: optional string trade_id = 22;
   */
  tradeId?: string;

  /**
   * End date if managed by Aurora; otherwise empty
   *
   * @generated from field: optional string end_date = 23;
   */
  endDate?: string;

  /**
   * Cash start date if managed by Aurora; otherwise empty
   *
   * @generated from field: optional string cash_start_date = 24;
   */
  cashStartDate?: string;

  /**
   * Time the execution was booked and acknowledged by the trader - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string acknowledged_at = 25;
   */
  acknowledgedAt?: string;

  /**
   * Execution status
   *
   * @generated from field: string status = 26;
   */
  status: string;

  /**
   * Execution status of other side
   *
   * @generated from field: string contra_status = 27;
   */
  contraStatus: string;

  /**
   * Reason of cancellation if status is cancelled
   *
   * @generated from field: optional string cancel_reason = 28;
   */
  cancelReason?: string;

  /**
   * Last Updated - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 29;
   */
  updatedAt: string;

  /**
   * Pricing currency of the execution
   *
   * @generated from field: aurora.core.common.protos.Currency pricing_currency = 30;
   */
  pricingCurrency: Currency;

  /**
   * @generated from field: optional string profit_center = 31;
   */
  profitCenter?: string;

  /**
   * Percentage of par value (unit_price * 100), only set for fixed income securities
   *
   * @generated from field: optional string percentage_par = 34;
   */
  percentagePar?: string;
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.FrontendExecution.
 * Use `create(FrontendExecutionSchema)` to create a new message.
 */
export const FrontendExecutionSchema: GenMessage<FrontendExecution> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 12);

/**
 * @generated from message aurora.core.apiengine.executionsv1.CancelExecutionRecordsRequest
 */
export type CancelExecutionRecordsRequest = Message<"aurora.core.apiengine.executionsv1.CancelExecutionRecordsRequest"> & {
  /**
   * @generated from field: repeated string execution_ids = 1;
   */
  executionIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.CancelExecutionRecordsRequest.
 * Use `create(CancelExecutionRecordsRequestSchema)` to create a new message.
 */
export const CancelExecutionRecordsRequestSchema: GenMessage<CancelExecutionRecordsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 13);

/**
 * @generated from message aurora.core.apiengine.executionsv1.CancelExecutionRecordsResponse
 */
export type CancelExecutionRecordsResponse = Message<"aurora.core.apiengine.executionsv1.CancelExecutionRecordsResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.executionsv1.CancelExecutionRecordsResponse.
 * Use `create(CancelExecutionRecordsResponseSchema)` to create a new message.
 */
export const CancelExecutionRecordsResponseSchema: GenMessage<CancelExecutionRecordsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_executions_executions, 14);

/**
 * @generated from enum aurora.core.apiengine.executionsv1.QueryExecutionRecordsSortableField
 */
export enum QueryExecutionRecordsSortableField {
  /**
   * @generated from enum value: UNSPECIFIED_QUERY_EXECUTION_RECORDS_SORTABLE_FIELD = 0;
   */
  UNSPECIFIED_QUERY_EXECUTION_RECORDS_SORTABLE_FIELD = 0,

  /**
   * Instrument (CUSIP or Ticker)
   *
   * @generated from enum value: INSTRUMENT = 1;
   */
  INSTRUMENT = 1,
}

/**
 * Describes the enum aurora.core.apiengine.executionsv1.QueryExecutionRecordsSortableField.
 */
export const QueryExecutionRecordsSortableFieldSchema: GenEnum<QueryExecutionRecordsSortableField> = /*@__PURE__*/
  enumDesc(file_modules_apiengine_services_executions_executions, 0);

/**
 * @generated from enum aurora.core.apiengine.executionsv1.ExecutionsReportType
 */
export enum ExecutionsReportType {
  /**
   * @generated from enum value: UNSPECIFIED_EXECUTIONS_REPORT_TYPE = 0;
   */
  UNSPECIFIED_EXECUTIONS_REPORT_TYPE = 0,

  /**
   * @generated from enum value: TYPE_0101 = 1;
   */
  TYPE_0101 = 1,

  /**
   * @generated from enum value: TYPE_7273 = 2;
   */
  TYPE_7273 = 2,

  /**
   * @generated from enum value: TYPE_ESEC = 3;
   */
  TYPE_ESEC = 3,
}

/**
 * Describes the enum aurora.core.apiengine.executionsv1.ExecutionsReportType.
 */
export const ExecutionsReportTypeSchema: GenEnum<ExecutionsReportType> = /*@__PURE__*/
  enumDesc(file_modules_apiengine_services_executions_executions, 1);

/**
 * @generated from service aurora.core.apiengine.executionsv1.ExecutionService
 */
export const ExecutionService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.executionsv1.ExecutionService.ListExecutions
   */
  listExecutions: {
    methodKind: "unary";
    input: typeof ListExecutionsRequestSchema;
    output: typeof ListExecutionsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.executionsv1.ExecutionService.AckExecutions
   */
  ackExecutions: {
    methodKind: "unary";
    input: typeof AckExecutionsRequestSchema;
    output: typeof AckExecutionsResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.executionsv1.ExecutionService.QueryExecutionRecords
   */
  queryExecutionRecords: {
    methodKind: "unary";
    input: typeof QueryExecutionRecordsRequestSchema;
    output: typeof QueryExecutionRecordsResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.executionsv1.ExecutionService.CustomExportAndAckExecutionRecords
   */
  customExportAndAckExecutionRecords: {
    methodKind: "unary";
    input: typeof CustomExportAndAckExecutionRecordsRequestSchema;
    output: typeof CustomExportAndAckExecutionRecordsResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.executionsv1.ExecutionService.CancelExecutionRecords
   */
  cancelExecutionRecords: {
    methodKind: "unary";
    input: typeof CancelExecutionRecordsRequestSchema;
    output: typeof CancelExecutionRecordsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_executions_executions, 0);

/**
 * @generated from service aurora.core.apiengine.executionsv1.ExecutionEventsService
 */
export const ExecutionEventsService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.executionsv1.ExecutionEventsService.Execution
   */
  execution: {
    methodKind: "unary";
    input: typeof ExecutionEventSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_executions_executions, 1);

